import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Eventph from "../../assets/pic/event.jpg"
import {Helmet} from "react-helmet";

const Event = ()=>{
    return(
        <div className='event-wrap'>
            <Helmet>
                <title>
                    رویدادهای آنلاین شبکه ای
                </title>
                <meta name="description" content="بسیاری از شرکت‌های بزرگ جهت برگزاری رویداد‌های درون سازمانی خود از شبکه‌های داخلی (Local Area Network : LAN) استفاده می‌کنند." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>رویدادهای شبکه ای</h1>
                <img src={Eventph} alt="رویداد آنلاین"/>
                <p>
                    برگزاری یک رویداد یا جلسه می‌تواند به صورت مجازی باشد. بسیاری از شرکت‌های بزرگ جهت برگزاری رویداد‌های درون سازمانی خود از شبکه‌های داخلی (Local Area Network : LAN) استفاده می‌کنند. استفاده از شبکه‌های داخلی باعث می‌شود تا ارتباط و شرکت در جلسات یا رویدادها برای افرادی که در خارج از آن سازمان هستند، دشوار باشد.
                </p>
                <p>
                    یک راه حل جهت رفع این مشکل، استفاده از شبکه جهانی وب (World Wide Web) یا به عبارتی همان اینترنت است. شبکه اینترنت، بستری است که امروزه بسیاری از کسب و کارها چه بزرگ و چه کوچک، از آن جهت انجام امور خود استفاده می‌کنند.
                </p>
                <p>
                    برگزاری رویدادهای شبکه ای (آنلاین) بر بستر اینترنت باعث می‌شود تا همه افراد فارغ از موقعیت جغرافیایی که دارند بتوانند در جلسات شرکت کنند. پلتفرم‌های جامعی که جهت برگزاری جلسات مجازی از آن‌ها استفاده می‌شود، باید دارای ابزارهای تعاملی استانداردی نظیر:
                </p>
                <ul>
                    <li>•	تعامل صوتی با کیفیت بالا</li>
                    <li>•	تعامل تصویری با کیفیت بالا با امکان برقراری چندین ارتباط تصویری</li>
                    <li>•	گفتگو و تعامل متنی (چت)</li>
                    <li>•	پخش ویدیو آنلاین</li>
                    <li>•	به اشتراک گذاری فایل</li>
                    <li>•	به اشتراک گذاری محتوای صفحه نمایش</li>
                    <li>•	و امکان ایجاد نمایش پیام یا اعلانات مهم به صورت دوره‌ای در محیط جلسه باشند.</li>
                </ul>
                <p>
                    پلتفرم جامع برگزاری جلسات مجازی BellMeet، تنها پتلفرم بومی و دانش بنیان با کامل‌ترین ابزار‌های تعاملی که در فوق نیز ذکر شد، آماده میزبانی بستر جلسات و رویدادهای شبکه ای شما است تا تجربه‌ای دلنشین و کارآمدتر از جلسات حضوری داشته باشید.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default Event